module.exports = __webpack_public_path__ + "pic2.jpg?0b96f1aed10eeec436aaecf59fc8ce54";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/pic2.jpg
// module id = 53
// module chunks = 13